import React from "react";
import type { Theme } from "@mui/material";

export const getLabelStyle = (theme: Theme): React.CSSProperties => ({
  color: theme.palette.text.secondary,
});

export const getValueStyle = (theme: Theme): React.CSSProperties => ({
  color: theme.palette.text.primary,
});
